import { render, staticRenderFns } from "./ReportePlaneacionSaldosPartidas.vue?vue&type=template&id=bc755626&"
import script from "./ReportePlaneacionSaldosPartidas.vue?vue&type=script&lang=js&"
export * from "./ReportePlaneacionSaldosPartidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports